module.exports = __webpack_public_path__ + "img/widgetBackground.27e78f0c.png";